// src/pages/Confidentialite.js
import React from 'react';
import '../styles/Confidentialite.css';

const Confidentialite = () => {
    return (
        <div className="confidentialite-page">
            <h1>Politique de Confidentialité</h1>

            <h2>1. Introduction</h2>
            <p>
                Le site Naninan est une plateforme dédiée à la promotion des événements cinématographiques, à l’information sur les sorties de films et à la publication d’avis par les utilisateurs.
            </p>
            <p>
                Cette Politique de Confidentialité a pour objectif d’informer l’Utilisateur sur les modalités de collecte, d’utilisation, de conservation et de protection de ses données personnelles lors de sa navigation et de son utilisation du site, édité par Africa Data Entry.
            </p>

            <h2>2. Responsable de Traitement</h2>
            <p><strong>Éditeur du Site :</strong> Africa Data Entry</p>
            <p><strong>Forme Juridique :</strong> Société à Responsabilité Limitée (SARL)</p>
            <p><strong>Siège Social :</strong> 17 BV 30065 OUAGA PISSY 10050 OUAGADOUGOU BURKINA FASO</p>
            <p><strong>Téléphone :</strong> <a href="tel:+22604443988">+226 04 44 39 88</a></p>
            <p><strong>Adresse e-mail :</strong> <a href="mailto:contact@africadataentry.com">contact@africadataentry.com</a></p>
            <p><strong>Numéro du RCCM :</strong> BF-OUA-01-2024-B12-14600</p>
            <p>
                Le responsable du traitement des données est Africa Data Entry. Pour toute question relative à la protection de vos données personnelles, l’Utilisateur peut contacter le service dédié à l’adresse e-mail mentionnée ci-dessus.
            </p>

            <h2>3. Données Collectées</h2>
            <h3>3.1. Données d’Identification et de Contact</h3>
            <p>
                Nom et prénom (lorsque communiqué volontairement), adresse e-mail, numéro de téléphone.
            </p>
            <h3>3.2. Données Générées par la Navigation</h3>
            <p>
                Adresse IP, type de navigateur et version, données de connexion (date et heure de visite, pages consultées), informations issues des cookies (voir notre Politique relative aux Cookies).
            </p>
            <h3>3.3. Données Issues des Interactions Utilisateur</h3>
            <p>
                Avis, commentaires et notations publiés sur les films, informations fournies via les formulaires de contact ou d’inscription à une newsletter.
            </p>

            <h2>4. Finalités du Traitement</h2>
            <p>
                Les données personnelles collectées sur Naninan sont utilisées pour :
            </p>
            <ul>
                <li>La gestion de la navigation et de la sécurité du site.</li>
                <li>L’amélioration du service, l’analyse de l’audience et l’ergonomie du site.</li>
                <li>L’interaction et l’engagement des utilisateurs (avis, commentaires, etc.).</li>
                <li>La communication commerciale et informationnelle (si l’utilisateur y a consenti).</li>
                <li>Le respect des obligations légales.</li>
            </ul>

            <h2>5. Base Légale du Traitement</h2>
            <p>
                Le traitement des données personnelles s’appuie sur le consentement explicite de l’Utilisateur, la nécessité d’exécuter un contrat, le respect d’une obligation légale ou l’intérêt légitime de Africa Data Entry.
            </p>

            <h2>6. Durée de Conservation des Données</h2>
            <p>
                Les données personnelles sont conservées pendant la durée nécessaire aux finalités pour lesquelles elles ont été collectées. Les données liées à la navigation sont généralement supprimées à la fin de la session. Les données relatives aux avis et interactions sont conservées tant que le compte utilisateur est actif, puis archivées selon les obligations légales.
            </p>

            <h2>7. Droits des Utilisateurs</h2>
            <p>
                Conformément aux lois applicables, l’Utilisateur dispose des droits d’accès, de rectification, d’effacement, d’opposition, de portabilité et de retrait de son consentement. Pour exercer ces droits, l’Utilisateur peut adresser une demande écrite à Africa Data Entry à l’adresse <a href="mailto:contact@africadataentry.com">contact@africadataentry.com</a>, accompagnée d’une copie d’une pièce d’identité.
            </p>

            <h2>8. Partage et Transfert des Données</h2>
            <p>
                Les données personnelles ne sont pas communiquées à des tiers, sauf lorsque nécessaire pour la gestion du site (prestataires, hébergeurs, etc.) ou en cas d’obligation légale. En cas de fusion, cession ou réorganisation, les données pourront être transférées à un tiers sous réserve de respecter les mêmes obligations.
            </p>

            <h2>9. Sécurité des Données</h2>
            <p>
                Africa Data Entry s’engage à mettre en œuvre des mesures techniques et organisationnelles appropriées pour garantir la sécurité et la confidentialité des données personnelles.
            </p>

            <h2>10. Liens Vers des Sites Tiers</h2>
            <p>
                Le Site peut contenir des liens vers des sites tiers dont la politique de confidentialité est indépendante. Africa Data Entry n’est pas responsable du contenu ou des pratiques de ces sites. Il est recommandé de consulter leurs politiques de confidentialité.
            </p>

            <h2>11. Modifications de la Politique de Confidentialité</h2>
            <p>
                Africa Data Entry se réserve le droit de modifier cette politique afin de l’adapter aux évolutions législatives ou techniques. Les modifications prennent effet dès leur publication sur le Site.
            </p>

            <h2>12. Contact</h2>
            <p>
                Pour toute question concernant cette Politique de Confidentialité, l’Utilisateur peut contacter Africa Data Entry par :
            </p>
            <ul>
                <li>Adresse e-mail : <a href="mailto:contact@africadataentry.com">contact@africadataentry.com</a></li>
                <li>Téléphone : <a href="tel:+22604443988">+226 04 44 39 88</a></li>
                <li>Adresse Postale : 17 BV 30065 OUAGA PISSY 10050 OUAGADOUGOU BURKINA FASO</li>
            </ul>
        </div>
    );
};

export default Confidentialite;
